(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-browse-tubes"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    const rows = [...root.querySelectorAll('[data-tube]')].map(el => ({el,system:el.dataset.system,id:Number(el.dataset.id),od:Number(el.dataset.od),wall:Number(el.dataset.wall),factor:Number(el.dataset.factor),variants:JSON.parse(el.dataset.variants),title:el.dataset.title.toLowerCase(),url:el.dataset.url}));
    const boxes = [...root.querySelectorAll('[data-system-filter]')];
    const filters = [...root.querySelectorAll('[data-filter]')];
    const search = root.querySelector('[data-search]');
    const stock = root.querySelector('[data-stock-filter]');
    const sort = root.querySelector('[data-sort]');
    const body = root.querySelector('tbody');
    const params = new URLSearchParams(location.search);
    const defaultSystem = root.dataset.defaultSystem || 'both';
    const requested = params.get('units');
    const selected = ['imperial','metric','both','none'].includes(requested) ? requested : defaultSystem;
    boxes.forEach(box => box.checked = selected === 'both' || box.value === selected);
    let page = 1;
    const pageSize = 20;
    const systems = () => boxes.filter(box => box.checked).map(box => box.value);
    const dimensionKey = (r,key) => `${r.system}|${r[key]}`;
    const lengthKey = (r,v) => `${r.system}|${v.length}`;
    function populate() {
      const pool = rows.filter(r => systems().includes(r.system));
      filters.forEach(select => {
        const key = select.dataset.filter, old = select.value, values = new Map();
        pool.forEach(r => {
          if (key === 'length') r.variants.forEach(v => values.set(lengthKey(r,v),{label:v.length,order:parseFloat(v.length)*r.factor}));
          else if (r[key] > 0) values.set(dimensionKey(r,key),{label:`${r[key]} ${r.system === 'metric' ? 'mm' : 'in'}`,order:r[key]*r.factor});
        });
        select.replaceChildren(new Option(root.dataset.all,''));
        [...values.entries()].sort((a,b) => a[1].order-b[1].order).forEach(([value,item]) => select.add(new Option(item.label,value)));
        if (values.has(old)) select.value = old;
      });
    }
    function render() {
      const active = systems(), term = search.value.trim().toLowerCase();
      const chosen = Object.fromEntries(filters.map(s => [s.dataset.filter,s.value]));
      const matches = [];
      rows.forEach(r => {
        r.el.hidden = true;
        if (!active.includes(r.system)) return;
        if (['id','od','wall'].some(key => chosen[key] && chosen[key] !== dimensionKey(r,key))) return;
        let variants = r.variants.filter(v => !chosen.length || chosen.length === lengthKey(r,v));
        if (term && !r.title.includes(term)) variants = variants.filter(v => (v.sku || '').toLowerCase().includes(term));
        if (stock.checked) variants = variants.filter(v => v.available);
        if (!variants.length) return;
        const byPrice = [...variants].sort((a,b) => a.price-b.price), low = byPrice[0], high = byPrice[byPrice.length-1];
        r.price = low.price;
        r.el.querySelector('[data-price-cell]').textContent = low.price === high.price ? low.priceText : `${low.priceText} – ${high.priceText}`;
        r.el.querySelector('[data-length-cell]').textContent = [...new Set(variants.map(v => v.length))].join(', ');
        const available = variants.some(v => v.available), status = r.el.querySelector('[data-stock-cell]');
        status.textContent = available ? root.dataset.available : root.dataset.soldOut;
        status.dataset.available = String(available);
        const target = new URL(r.url,location.origin);
        if (variants.length === 1) target.searchParams.set('variant',variants[0].id);
        if (params.has('preview_theme_id')) target.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
        r.el.querySelector('[data-product-link]').href = target.pathname + target.search;
        matches.push(r);
      });
      matches.sort((a,b) => sort.value === 'price-up' ? a.price-b.price : sort.value === 'price-down' ? b.price-a.price : a.id*a.factor-b.id*b.factor || a.od*a.factor-b.od*b.factor);
      const pages = Math.max(1,Math.ceil(matches.length/pageSize));
      page = Math.min(page,pages);
      matches.forEach((r,i) => { body.append(r.el); r.el.hidden = i < (page-1)*pageSize || i >= page*pageSize; });
      root.querySelector('[data-result-count]').textContent = root.dataset.results.replace('{shown}',matches.length).replace('{total}',rows.length);
      root.querySelector('[data-empty]').hidden = matches.length !== 0;
      root.querySelector('[data-pagination]').hidden = matches.length <= pageSize;
      root.querySelector('[data-page-count]').textContent = root.dataset.page.replace('{current}',page).replace('{total}',pages);
      root.querySelector('[data-prev]').disabled = page === 1;
      root.querySelector('[data-next]').disabled = page === pages;
    }
    function updateURL() {
      const url = new URL(location.href), active = systems();
      const choice = active.length === 2 ? 'both' : active[0] || 'none';
      if (choice === defaultSystem) url.searchParams.delete('units');
      else url.searchParams.set('units',choice);
      history.replaceState(null,'',url);
    }
    boxes.forEach(box => box.addEventListener('change',() => {page=1;populate();updateURL();render();}));
    [...filters,stock,sort].forEach(input => input.addEventListener('change',() => {page=1;render();}));
    search.addEventListener('input',() => {page=1;render();});
    root.querySelector('[data-reset]').addEventListener('click',() => {boxes.forEach(box => box.checked=defaultSystem === 'both' || box.value === defaultSystem);search.value='';stock.checked=false;sort.value='size';filters.forEach(s => s.value='');page=1;populate();updateURL();render();});
    root.querySelector('[data-prev]').addEventListener('click',() => {page--;render();root.querySelector('[data-result-count]').scrollIntoView({block:'start'});});
    root.querySelector('[data-next]').addEventListener('click',() => {page++;render();root.querySelector('[data-result-count]').scrollIntoView({block:'start'});});
    populate();render();root.querySelector('[data-controls]').hidden=false;root.dataset.ready='true';
  };
  document.querySelectorAll('[data-tube-browser]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-tube-browser]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
